import React from 'react';
import Footer from '../Footer';
import Header from '../Header';
import SearchTemplate from '../SearchTemplate';

function SearchPage() {
  return (
  <div>
      <Header/>
      <SearchTemplate/>
      <Footer/>
  </div>
  );
}

export default SearchPage;
